import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../Components/assets/icons/a1.png";
import colunms from "../../Components/assets/icons/LINES.png";
import pen from "../../Components/assets/icons/pen.png";
import basket from "../../Components/assets/icons/basket.png";
import search1 from "../../Components/assets/icons/search.png";
import top from "../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../assets/icons/circle.png";
import rigth from "../assets/icons/rigth.png";
import save from "../assets/icons/save.png";
import cancel from "../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";
import { Context } from "../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import toast, { Toaster } from "react-hot-toast";
import classNames from "classnames";

import { formatDate, timeShow } from "../../utils/common";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";

import Pagination from "react-bootstrap/Pagination";
import Pagination_Holder from "../common/Pagination_Holder/Pagination_Holder";
import Successfull_Modal from "../common/Successfull_Modal/Successfull_Modal";
library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    getDownloadDataExcel,
    Per_Page_Dropdown,
    postData,
    userdata,
  } = useContext(Context);

  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [successModal, setSuccessModal] = useState(false);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [stage, setStage] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDate, setSearchDate] = useState("");
  const [orderDate, setOrderDate] = useState("");

  const getDataAll = async () => {
    const response = await getData(
      `/wallet-history?page=${onPageChange}&per_page=${perPage}&term=${search}&stage=${stage}&from=${
        from ? formatDate(from) : ""
      } &to=${to ? formatDate(to) : ""}&orderDate=${
        orderDate ? formatDate(orderDate) : ""
      }`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    // setCurrentPage(response?.data?.);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  const [insufficient, setInsufficient] = useState("");
  const onSubmit = async (data) => {
    const res = await postData(`/wallet-history/add`, data);
    if (res?.success) {
      setSuccessModal(true);
      setInsufficient("");
      setTimeout(() => {
        setSuccessModal(false);
        handleClose(true);
        getDataAll();
      }, 3000);
    } else {
      setInsufficient(res.message);
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    search,
    stage,
    searchDate,
    onPageChange,
    orderDate,
    from,
    to,
  ]);

  const ChangeStage = async (id, appr) => {
    const response = await postData(`/withdrawl-request/request/${id}`, appr);
    setChangeStatus(response);
  };

  // Modal function
  const [showModel, setShowModel] = useState(false);

  const handleClose = () => setShowModel(false);
  const handleShow = () => setShowModel(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const [showTakeAnAction, setTakeAnActionShow] = useState(false);

  const handleTakeAnActionClose = () => setTakeAnActionShow(false);
  const handleTakeAnActionShow = () => setTakeAnActionShow(true);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },

    watch,
    getValues,
  } = useForm();

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/withdrawl-request/${recordToDeleteId}`
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
    col14: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/wallet-history/downloads",
          selectAllChecked,
          "WithDrawl Request list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Wallet History"} link={"/wallet-history"} />
        <section className="AdvanceDashboard">
          <div className="row ">
            <div className="col-lg-12">
              <div className="row MainRowsec">
                <section className="Tabels tab-radio tab-radio mt-3">
                  <div className="">
                    <div className="row">
                      <div className="d-flex">
                        {/* <div className="add">
                      <Button
                        variant="success"
                        className="btn btn-view"
                        onClick={HandleDownload}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon="fa-solid fa-download"
                          className="me-2"
                        />
                        Download
                      </Button>
                    </div> */}
                      </div>
                      <div className="border-line my-3"></div>
                      <div className="row ">
                        <div className=" col-12"></div>
                        <div className=" col-12">
                          <div className="row align-items-end">
                            <div className=" col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2">
                                <Form.Label>Amount</Form.Label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Amount"
                                  id=""
                                  value={search}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>

                              {/* <div className="Search me-2">
                                <button
                                  type="button"
                                  onClick={getDataAll}
                                  className="btn btn-search btn btn-primary w-100"
                                >
                                  <img
                                    src={search1}
                                    className="search"
                                    alt=""
                                  />
                                </button>
                              </div> */}
                            </div>

                            {userdata?.data?.id == 1 && (
                              <div className="  col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                                {" "}
                                <div className="num me-2">
                                  <Form.Label>User Type</Form.Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="User Type "
                                    id=""
                                    value={stage}
                                    onChange={(e) => {
                                      setStage(e.target.value);
                                      handlePageChange(1);
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            <div className="  col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <Form.Label>Payment From</Form.Label>
                              <input
                                type="date"
                                className="form-control"
                                value={from}
                                onChange={(e) => {
                                  setFrom(e.target.value);
                                  handlePageChange(1);
                                  setTo("");
                                }}
                                max={new Date().toISOString().split("T")[0]}
                                onInput={(e) => {
                                  const inputValue = e.target.value;
                                  const [year, month, day] =
                                    inputValue.split("-");
                                  if (year && year.length > 4) {
                                    e.target.value = `${year.slice(0, 4)}-${
                                      month || ""
                                    }-${day || ""}`.replace(/-+$/, "");
                                  }
                                }}
                              />
                            </div>

                            <div className="  col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <Form.Label>Payment To</Form.Label>
                              <input
                                type="date"
                                className="form-control"
                                value={to}
                                onChange={(e) => {
                                  setTo(e.target.value);
                                  handlePageChange(1);
                                }}
                                min={from}
                                max={new Date().toISOString().split("T")[0]}
                                onInput={(e) => {
                                  const inputValue = e.target.value;
                                  const [year, month, day] =
                                    inputValue.split("-");
                                  if (year && year.length > 4) {
                                    e.target.value = `${year.slice(0, 4)}-${
                                      month || ""
                                    }-${day || ""}`.replace(/-+$/, "");
                                  }
                                }}
                              />
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2">
                                {" "}
                                <Form.Label>Order Date</Form.Label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id=""
                                  value={orderDate}
                                  onChange={(e) => {
                                    setOrderDate(e.target.value);
                                    handlePageChange(1);
                                  }}
                                  max={new Date().toISOString().split("T")[0]}
                                  onInput={(e) => {
                                    const inputValue = e.target.value;
                                    const [year, month, day] =
                                      inputValue.split("-");
                                    if (year && year.length > 4) {
                                      e.target.value = `${year.slice(0, 4)}-${
                                        month || ""
                                      }-${day || ""}`.replace(/-+$/, "");
                                    }
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
                              <button
                                className="btn btn-success "
                                onClick={HandleDownload}
                              >
                                <FontAwesomeIcon
                                  className="me-1"
                                  icon={faDownload}
                                />
                                Downlaod Excel
                              </button>
                            </div>

                            <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                              <div className="Search-1">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSearch("");
                                    setSearchDate("");
                                    setOrderDate("");
                                    setStage("");
                                    setFrom("");
                                    setTo("");
                                    setReset(!reset);
                                  }}
                                  className="btn btn-reset w-100"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>

                            <div className="d-flex mt-4">
                              {userdata?.data?.type == "Seller" && (
                                <div className="my-auto">
                                  <b>My Wallet Amount :</b> ₹{" "}
                                  {userdata?.data?.wallet_amount || 0}
                                </div>
                              )}
                              {userdata?.data?.type == "Seller" && (
                                <div className="button-recharge ms-3">
                                  <button
                                    className="btn btn-recharge"
                                    onClick={handleShow}
                                  >
                                    Withdraw Request
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line my-3"></div>
                  <div className="row mt-3">
                    <div className="data  withdrow-table-holder table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            <th className="check round-check">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="selectAll"
                                  checked={
                                    allChecked.length ===
                                    selectAllChecked.length
                                  }
                                  onChange={handleChange}
                                  id="selectAll"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexCheckChecked"
                                ></label>
                              </div>
                            </th>
                            {visible.col1 && <th className="sr">Sr. No.</th>}
                            {visible.col2 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                User Type
                              </th>
                            )}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Transaction Type
                              </th>
                            )}{" "}
                            {visible.col5 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                User Name
                              </th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Order ID
                              </th>
                            )}{" "}
                            {visible.col6 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Amount
                              </th>
                            )}{" "}
                            {visible.col7 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Order Payment Type
                              </th>
                            )}{" "}
                            {visible.col10 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Payment Date
                              </th>
                            )}{" "}
                            {visible.col11 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Payment Status Update Date
                              </th>
                            )}{" "}
                            {visible.col8 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Order Date
                              </th>
                            )}{" "}
                            {/* {visible.col9 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Order Status Update Date
                              </th>
                            )}{" "} */}
                            {visible.col13 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Account Number
                              </th>
                            )}{" "}
                            {visible.col14 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                IFSC Code
                              </th>
                            )}{" "}
                            {visible.col12 && (
                              <th className="tax-name" style={{ width: "20%" }}>
                                Withdraw Status
                              </th>
                            )}
                            {/* {visible.col4 && <th className="active">Action</th>} */}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.length > 0 ? (
                            data.data.data.map((d, index) => {
                              const paginatedIndex =
                                (onPageChange - 1) * perPage + index + 1;
                              return (
                                <tr className="" key={index}>
                                  <td>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={d?.id}
                                        name="perselected"
                                        checked={selectAllChecked.includes(
                                          d?.id
                                        )}
                                        onChange={handleChange}
                                        id={`flexCheckDefault-${index}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexCheckDefault-${index}`}
                                      ></label>
                                    </div>
                                  </td>
                                  {visible.col1 && <td>{paginatedIndex}.</td>}
                                  {visible.col2 && (
                                    <td>{d?.user_type || "-"}</td>
                                  )}
                                  {visible.col3 && <td>{d?.type}</td>}
                                  {visible.col5 && (
                                    <td>{d?.user?.first_name}</td>
                                  )}{" "}
                                  {visible.col4 && (
                                    <td>
                                      {d?.orders_detail?.id ? (
                                        <Link
                                          to={`/order-managements/order/${d?.orders_detail?.id}`}
                                        >
                                          {d?.orders_detail?.id}
                                        </Link>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  )}
                                  {visible.col6 && <td>₹ {d?.amount}</td>}
                                  {visible.col7 && (
                                    <td>{d?.order?.payment_mode || "-"}</td>
                                  )}{" "}
                                  {visible.col10 && (
                                    <td>
                                      {new Date(
                                        d?.createdAt
                                      ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </td>
                                  )}
                                  {visible.col11 && (
                                    <td>
                                      {new Date(d?.updatedAt).toLocaleString(
                                        "en-GB",
                                        {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          second: "2-digit",
                                          hour12: true, // Shows AM/PM format
                                        }
                                      )}
                                    </td>
                                  )}
                                  {visible.col8 && (
                                    <td>
                                      {" "}
                                      {d?.order?.createdAt
                                        ? new Date(
                                            d?.order?.createdAt
                                          ).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                          })
                                        : "-"}
                                    </td>
                                  )}
                                  {/* {visible.col9 && (
                                    <td>
                                      {d?.order?.updatedAt
                                        ? new Date(
                                            d?.order?.updatedAt
                                          ).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true,
                                          })
                                        : "-"}
                                    </td>
                                  )} */}
                                  {visible.col13 && (
                                    <td>{d.account_number || "-"}</td>
                                  )}{" "}
                                  {visible.col14 && (
                                    <td>{d.ifsc_code || "-"}</td>
                                  )}
                                  {visible.col12 && (
                                    <td>{d.request_status || "-"}</td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="15" className="text-center">
                                Data not available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>{" "}
                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button
                    className="btn btn-yes me-2"
                    onClick={handleDeleteRecord}
                  >
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="take-an-action-modal-holder">
        <Modal
          className="take-an-action-modal "
          show={showTakeAnAction}
          onHide={handleTakeAnActionClose}
          animation={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Take an action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Group>
              <InputGroup>
                <Controller
                  // name={`stage-${index}`} // name of the field
                  control={control}
                  rules={{
                    required: "Take an Action",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.stage
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                      }}
                      options={[
                        {
                          value: "Approved",
                          label: "Approve",
                        },
                        {
                          value: "Rejected",
                          label: "Reject",
                        },
                      ]}
                    />
                  )}
                />
              </InputGroup>
              {errors.stage && (
                <p style={{ color: "red" }}>{errors.stage.message}</p>
              )}
            </Form.Group> */}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-no" onClick={handleTakeAnActionClose}>
              Close
            </Button>
            <Button className="btn-yes" onClick={handleTakeAnActionClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Toaster position="top-right" />

      <>
        <div className="withrow-request Reason_Modal">
          <Modal
            className="withrow_request Cancel_Reason_Modal"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showModel}
            onHide={handleClose}
          >
            <Modal.Header closeButton>Withdrawal Request</Modal.Header>
            <Form role="form">
              <Modal.Body>
                <div className="col-md-6">
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <Form.Label>Amount</Form.Label>
                      <div>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            name="amount"
                            placeholder="Amount"
                            className={classNames("", {
                              "is-invalid": errors?.amount,
                            })}
                            {...register("amount", {
                              required: "Amount is required",
                              validate: (value) => {
                                // Check if the value is a number and an integer
                                if (!Number.isInteger(Number(value))) {
                                  return "Amount must be an integer.";
                                }

                                // Check if the value is non-negative
                                if (value < 0) {
                                  return "Amount cannot be negative.";
                                }

                                // Check if the amount is less than or equal to wallet amount
                                if (value > userdata?.wallet_amount) {
                                  return `Insufficient Wallet Balance`;
                                }

                                // If all conditions are satisfied, return true
                                return true;
                              },
                            })}
                          />
                        </InputGroup>
                        {errors.amount && (
                          <span className="text-danger">
                            {errors.amount.message}
                          </span>
                        )}
                      </div>

                      <div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="account_number"
                            placeholder="Account Number"
                            className={classNames("", {
                              "is-invalid": errors?.account_number,
                            })}
                            {...register("account_number", {
                              required: "Account Number is required",
                              validate: (value) => {
                                // Check if the value is a number and an integer

                                // If all conditions are satisfied, return true
                                return true;
                              },
                            })}
                          />
                        </InputGroup>
                        {errors.account_number && (
                          <span className="text-danger">
                            {errors.account_number.message}
                          </span>
                        )}
                      </div>

                      <div>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="ifsc_code"
                            placeholder="IFSC Code"
                            className={classNames("", {
                              "is-invalid": errors?.ifsc_code,
                            })}
                            {...register("ifsc_code", {
                              required: "Ifsc Code is required",
                              validate: (value) => {
                                // Check if the value is a number and an integer

                                // If all conditions are satisfied, return true
                                return true;
                              },
                            })}
                          />
                        </InputGroup>
                        {errors.ifsc_code && (
                          <span className="text-danger">
                            {errors.ifsc_code.message}
                          </span>
                        )}
                      </div>

                      {<span className="text-danger">{insufficient}</span>}
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button className="close-btn" onClick={handleClose}>
                  Close
                </Button>
                <Button className="save-btn" onClick={handleSubmit(onSubmit)}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </div>
      </>

      <Successfull_Modal
        show={successModal}
        onHide={() => setSuccessModal(false)}
        message={"Wallet Request Sent Successfully"}
      />
    </>
  );
};

export default Tables;
